import React from 'react'
import { BottomArroe } from '../utils/icons'

function Notes() {
    return (
        <div>
            <div className='flex justify-between items-center mb-5'>
                <h1 className='font-semibold text-lg'>Program</h1>
                <p className='text-xs'>0 out of 7 Completed</p>
            </div>
            <div className='space-y-2'>
                {[...Array(5)].map((_, i) => {
                    return < div key={i} className='flex justify-between shadow-programSHadow p-4 rounded-3xl'>
                        <div>
                            <h1 className='font-semibold text-lg'>Why is user experience important ?</h1>
                            <p className='text-xs'>Module 01 - 25 Hours</p>
                        </div>
                        <button className='flex items-center gap-2 text-sm text-darkOrange'>Show Details <BottomArroe /></button>
                    </div>
                })}
            </div>
        </div >
    )
}

export default Notes